// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NVWA","tabsBox":"styles_tabsBox__3tCVX","createButton":"styles_createButton__3LyGY"};